import type { AgentConversationSummaryDto } from "../../autogen/bff-api";

export const newestFirst = (
  newest: AgentConversationSummaryDto[],
  older: AgentConversationSummaryDto[],
): AgentConversationSummaryDto[] => {
  const seen = new Set<string>();
  return [...newest, ...older]
    .filter((conversation) => !seen.has(conversation.id) && seen.add(conversation.id))
    .sort((a, b) => b.modifiedAt.localeCompare(a.modifiedAt));
};

export interface OlderConversations {
  conversations: AgentConversationSummaryDto[];
  nextBefore: string | null;
}

export const withOlderPage = (
  older: OlderConversations | null,
  newestPage: AgentConversationSummaryDto[],
  page: { conversations: AgentConversationSummaryDto[]; nextBefore?: string | null },
): OlderConversations => ({
  conversations: [...(older?.conversations ?? newestPage), ...page.conversations],
  nextBefore: page.nextBefore ?? null,
});
